module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "ctll",
    attrs: {
      "id": "p0007-01-0"
    }
  }, [_c('span', [_c('em', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctu",
    attrs: {
      "id": "p0007-P-1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter3#p0009-01-0"
    }
  }, [_c('em', [_vm._v("Introduction: The Jesus Story ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-2"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter4#cccc1",
      "id": "cha1"
    }
  }, [_vm._v("1. Christ Before Time ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-3"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter5#cccc2",
      "id": "cha2"
    }
  }, [_vm._v("2. Christ in Creation: The Macro Version ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter6#cccc3",
      "id": "cha3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Christ in Creation: The Micro Version ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-5"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter7#cccc4",
      "id": "cha4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Jesus’ Birth and Boyhood ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-6"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter8#cccc5",
      "id": "cha5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Jesus’ Missing Years ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-7"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter9#cccc6",
      "id": "cha6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Jesus’ Preparation for Ministry ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-8"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter10#cccc7",
      "id": "cha7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Jesus’ Baptism and Temptation ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-9"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter11#cccc8",
      "id": "cha8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Jesus Chooses His Disciples ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter12#cccc9",
      "id": "cha9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Jesus’ Mission Statement ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-11"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter13#cccc10",
      "id": "cha10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Jesus: Healer and Miracle-Worker ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter14#cccc11",
      "id": "cha11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Jesus: Teacher and Preacher ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter15#cccc12",
      "id": "cha12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Human Jesus ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-14"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter16#cccc13",
      "id": "cha13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Jesus’ Trial and Crucifixion ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-15"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter17#cccc14",
      "id": "cha14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Atonement and the Harrowing of Hell ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-16"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter18#cccc15",
      "id": "cha15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Resurrection, Ascension, and Pentecost ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-17"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter19#cccc16",
      "id": "cha16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Return of the King"), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "cctu",
    attrs: {
      "id": "p0007-P-18"
    }
  }, [_c('span', [_c('em', [_c('span', {
    attrs: {
      "href": "#/chapter20#cccc17",
      "id": "cha17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Jesus Spirit")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctu",
    attrs: {
      "id": "p0007-P-19"
    }
  }, [_c('span', [_c('em', [_c('span', {
    attrs: {
      "href": "#/chapter21#cccc18",
      "id": "cha18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Post-Apostolic Witnesses")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctu",
    attrs: {
      "id": "p0007-P-20"
    }
  }, [_c('span', [_c('em', [_c('span', {
    attrs: {
      "href": "#/chapter22#cccc19",
      "id": "cha19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cctu",
    attrs: {
      "id": "p0007-P-21"
    }
  }, [_c('span', [_c('em', [_c('span', {
    attrs: {
      "href": "#/chapter23#cccc20",
      "id": "cha20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors ")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff5012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 72
// module chunks = 0